var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 44,
    viewBox: "0 0 130 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0588 13.6199L114.487 5.87952C121.001 4.69118 127 9.6946 127 16.316C127 25.2613 116.609 30.191 109.681 24.5328L109.071 24.0343C103.789 19.7213 96.4404 18.9852 90.4086 22.1651L70.9962 32.3992C65.7836 35.1472 60.0733 36.8232 54.2023 37.328L12.6952 40.8973C7.48059 41.3457 3 37.2338 3 32V22.1066C3 11.5543 11.5543 3 22.1066 3C24.8924 3 27.6446 3.6092 30.1702 4.7849L40.4312 9.56158C50.2995 14.1555 61.3503 15.5734 72.0588 13.6199Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack8);
export default __webpack_public_path__ + "static/media/track8.07abd300.svg";
export { ForwardRef as ReactComponent };